import moment from 'moment'

/**
 * This class works like a type that handles groups of dates. It also works as a facade for the libraries we use for
 * date handling. This class might need some rework so individual date handling is done by another class and this
 * class only handles ranges of dates.
 */
export default class DateRange {
  get format() {
    return this._currentFormat
  }

  get start() {
    return this.DateStart === '' ? '' : this.DateStart.format(this._currentFormat)
  }

  set start(date) {
    if ((date === null || date === '') && this._unsafe) {
      this.DateStart = ''
    } else {
      this.DateStart = moment(date, this._currentFormat)
      this.DateStart = this.formatIncludesDays ? this.DateStart : this.DateStart.startOf('month')
    }
  }

  get end() {
    return this.DateEnd === '' ? '' : this.DateEnd.format(this._currentFormat)
  }

  set end(date) {
    if ((date === null || date === '') && this._unsafe) {
      this.DateEnd = ''
    } else {
      this.DateEnd = moment(date, this._currentFormat)
      this.DateEnd = this.formatIncludesDays ? this.DateEnd : this.DateEnd.endOf('month')
    }
  }

  get isUnsafe() {
    return this._unsafe
  }

  get isFilled() {
    return this.start !== '' && this.end !== ''
  }

  get formatIncludesDays() {
    return this.format.toLowerCase().includes('dd')
  }

  constructor({ format = 'MM/YYYY', date = undefined, unsafe = false } = {}) {
    this._currentFormat = format
    this._unsafe = unsafe
    this._settings = { format, date, unsafe }
    if (!unsafe) {
      this.DateStart = moment(date, date ? format : undefined)
        .subtract(1, 'years')
        .startOf('month')
      this.DateEnd = moment(date, date ? format : undefined).endOf('month')
    } else {
      this.DateStart = ''
      this.DateEnd = ''
    }
  }

  convertToFormat(format) {
    this._currentFormat = format
  }

  toString() {
    return `${this.start} - ${this.end}`
  }

  static convertToFormat(range, format) {
    const nRange = DateRange.copy(range)
    nRange.convertToFormat(format)
    return nRange
  }

  static fromString({
    str,
    split = ',',
    format = 'MM/YYYY',
    fallback = undefined,
    unsafe = false,
  } = {}) {
    const res = str.split(split)
    if (res.length !== 2) {
      if (fallback !== undefined) {
        return fallback
      }
      return new DateRange({ format, unsafe })
    }
    return DateRange.fromDateRange({
      start: res[0],
      end: res[1],
      format,
      unsafe,
    })
  }

  static fromDateRange({ start, end, format = 'MM/YYYY', unsafe = false } = {}) {
    const range = new DateRange({ format, unsafe })

    range.start = start
    range.end = end

    return range
  }

  static copy(range) {
    const nRange = new DateRange(range._settings)
    nRange.start = range.start
    nRange.end = range.end

    return nRange
  }
}
